<script lang="ts">
    import ResultsHeader from '$saga/views/Search/ResultsHeader.svelte';

    export let searchResultTotal: number,
        hideButtons: boolean = false,
        searchDatalayer: string = '',
        dict: any;
</script>

<ResultsHeader {searchResultTotal} {hideButtons} {searchDatalayer} {dict} />
